import { AxiosRequestConfig } from 'axios';

export const baseConfig = {
	baseURL: import.meta.env.VITE_PC_API_HOST ?? '',
	maxRedirects: 5,
	responseType: 'json',
	timeout: 60000,
} as AxiosRequestConfig;
